import React from 'react';
import * as LucideIcons from 'lucide-react';

export type IconName = keyof typeof LucideIcons;

interface DynamicIconProps extends Omit<LucideIcons.LucideProps, 'ref'> {
  name: string;
}

export const DynamicIcon: React.FC<DynamicIconProps> = ({ name, ...props }) => {
  // @ts-ignore
  const IconComponent = LucideIcons[name] as React.ElementType;

  if (!IconComponent) {
    // Fallback icon if name is invalid or not found
    const Fallback = LucideIcons.Box;
    return <Fallback {...props} />;
  }

  return <IconComponent {...props} />;
};
